import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isEmpty, isNil } from 'lodash';
// Import Components
import { ColumnChart, BusyLoader, Empty } from '@geneui/components';
import SectionWithTitle from 'components/common/SectionWithTitle';
// Import Constants
import { l } from 'constants/common';

const CampaignCountOfData = ({ isLoading, data, title }) => {
    const { t } = useTranslation();
    const [chartData, setChartData] = useState<[string, number][]>([]);
    const [chartCategories, setChartCategories] = useState<string[]>([]);

    const init = () => {
        if (isNil(data)) return;
        const chartData: [string, number][] = [];
        const categories: string[] = [];
        data.forEach(function ({ date, value }) {
            chartData.push([String(date), value]);
            categories.push(date);
        });
        setChartData(chartData);
        setChartCategories(categories);
    };

    useEffect(init, [data]);

    return (
        <SectionWithTitle title={title} hasContentPadding={false} contentClassName="c-r-v-swt-content">
            {isLoading ? (
                <BusyLoader spinnerSize="big" isBusy={true} />
            ) : isNil(data) || isEmpty(data) ? (
                <Empty title={t(l.NoDataToDisplay)} />
            ) : (
                <ColumnChart data={chartData} color={'rgb(1, 236, 197)'} categories={chartCategories} />
            )}
        </SectionWithTitle>
    );
};

CampaignCountOfData.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    title: PropTypes.string,
};

CampaignCountOfData.defaultProps = {
    isLoading: false,
    title: '',
};
export default memo(CampaignCountOfData);
